import React from 'react'
import { Redirect } from 'react-router-dom'
import { connect } from 'react-redux'

// Helpers
import * as Auth from '../../utils/auth.js'

const RequireAdmin = ({ user }) => (
  Auth.isAdmin(user) ? null : <Redirect to="/404" />
)

const mapStateToProps = (state) => ({
  user: state.user
})

export default connect(mapStateToProps)(RequireAdmin)



// WEBPACK FOOTER //
// ./src/components/Admin/RequireAdmin.js